module.exports = __webpack_public_path__ + "img/pic_9.842ad95b.jpg";